export const TYPE_CLASS = {
    '商场': 'shop',
    '不利因素': 'harm',
    '三甲': 'hospital',
    '三乙': 'hospital',
    '幼儿园': 'school',
    '小学': 'school',
    '中学': 'school',
    '主干道': 'road',
    '地铁': 'metro',
    '公园': 'park'
}
export const DEFAULT_COLOR = '#00B08D'
export const ACTIVE_COLOR = '#FF4D00'

export const TABS = [
    {
        name: '交通',
        type: 'bus'
    },
    {
        name: '教育',
        type: 'school'
    },
    {
        name: '医院',
        type: 'hospital'
    },
    {
        name: '购物',
        type: 'shopping'
    },
    {
        name: '环境',
        type: 'env'
    }
]